export default __webpack_public_path__ + "static/media/denise.6a43e104.png";